import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { Typography, Button } from 'antd';
import account from '@/common/account/index';
import whichEnvironment from '@/common/utils/whichEnvironment';
import less from './Banner.less';

const StyledBanner = styled.div`
  position: relative;
  margin-top: -1px;
`;
const StyledBannerImage = styled.img`
  width: 100%;
  display: block;
`;
const StyledBannerContent = styled.div`
  min-width: 41%;
  max-width: 50%;
  height: 200px;
  color: #fff;
  position: absolute;
  top: 30%;
  left: 15%;
  & .ant-typography,
  button {
    color: #fff;
  }
  & div.ant-typography {
    font-size: 16px;
    line-height: 1.55;
  }
  & .ant-btn {
    background-color: transparent;
    font-size: 14px;
    margin-top: 43px;
  }
  & .ant-btn-lg {
    padding: 0 30px;
  }
  & .btn-fill {
    margin-right: 20px;
    color: #5187d5;
    background-color: #fff;
    border: none;

    &:hover {
      background-color: #d8e1ed;
    }
  }
  & .btn {
    margin-right: 20px;
    &:hover {
      color: #fff;
      background-color: #5187d5;
      border: 1px solid #5187d5;
      transition: 0.4s;
    }
    &:focus {
      color: #fff;
      background-color: #5187d5;
      border: none;
      transition: 0.4s;
    }
  }
`;

const { Title, Paragraph } = Typography;
const TalBanner = ({
  image,
  title,
  desc,
  link,
  tryLink,
  docLink,
  experience
}) => {
  const router = useRouter();
  const name = router.query.name;
  function linkPaas() {
    const loginEd = account.hasLoggedin();
    const env = whichEnvironment();
    if (loginEd) {
      if (env === 'RELEASE') {
        window.open(
          'https://openai.100tal.com/console/manage/homepage',
          '_blank'
        );
      } else {
        window.open(
          'https://gateway-test-multi.facethink.com/console/manage/homepage',
          '_blank'
        );
      }
    } else {
      window.open('/account/login', '_blank');
    }
  }

  return (
    <StyledBanner>
      <StyledBannerImage src={image} alt="好未来AI开放平台" />
      <StyledBannerContent>
        <Title>{title}</Title>
        <Paragraph>{desc}</Paragraph>
        {name === 'correct_solution' && (
          <div className={less.EnterpriseWeChat}>
            <Button size="large" className="btn-fill">
              App体验
            </Button>
            <div className={less.singleImgBox}>
              <div className={less.triangle} />
              <img
                src="https://openplantform.oss-cn-beijing.aliyuncs.com/index/AiSolution/correct_solution_download.png"
                alt=""
              />
            </div>
          </div>
        )}
        {/* 官网体验 */}
        {name === 'problem_solving' && (
          <Button
            size="large"
            className="btn-fill"
            onClick={() => window.open('https://playground.xes1v1.cn/MathGPT')}
          >
            官网体验
          </Button>
        )}
        {name === 'problem_solving' && (
          <div className={less.EnterpriseWeChat}>
            <Button size="large" className="btn-fill">
              小程序体验
            </Button>
            <div
              className={classnames(less.singleImgBox, less.wechatAppImgBox)}
            >
              <div className={less.triangle} />
              <img
                src="https://openplantform.oss-cn-beijing.aliyuncs.com/index/AiSolution/problem_solving_wechat.png"
                alt=""
              />
            </div>
          </div>
        )}
        {link && link.content && (
          <Button
            size="large"
            className="btn-fill"
            onClick={() => window.open(link.to)}
          >
            {link.content}
          </Button>
        )}
        {tryLink && tryLink.show && (
          <Button
            size="large"
            onClick={() => linkPaas(tryLink.show)}
            className={tryLink.index === 0 ? 'btn-fill' : 'btn'}
          >
            {tryLink.content}
          </Button>
        )}
        {docLink && docLink.to && (
          <Button
            size="large"
            onClick={() => window.open(docLink.to)}
            className="btn"
          >
            {docLink.content}
          </Button>
        )}
        {experience && experience.content && (
          <Button
            size="large"
            className="btn"
            onClick={() => window.open(experience.to)}
          >
            {experience.content}
          </Button>
        )}
        <div className={less.EnterpriseWeChat}>
          <Button size="large" className="btn">
            企业微信
          </Button>
          <div className={less.EnterpriseWeChatHoverImgBox}>
            <div className={less.triangle} />
            <div className={less.text}>
              <p>扫描二维码</p>
              <p>添加企业微信</p>
              <p>了解更多信息</p>
            </div>
            <img src="../../static/navigator/enterwechat.png" alt="" />
          </div>
        </div>
      </StyledBannerContent>
    </StyledBanner>
  );
};

TalBanner.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  link: PropTypes.shape({
    to: PropTypes.string,
    content: PropTypes.string
  }),
  tryLink: PropTypes.shape({
    to: PropTypes.string,
    content: PropTypes.string,
    index: PropTypes.number
  }),
  docLink: PropTypes.shape({
    to: PropTypes.string,
    content: PropTypes.string
  })
};

export default TalBanner;
